<template>
	<div>
		<v-alert v-if="showText" type="info">
			{{ finaltext }}
		</v-alert>
		<v-card v-if="renderForm" max-width="300" class="mx-auto" flat>
			<v-form>
				<logo style="max-height: 30vh;" />
				<v-card-text>
					<!-- email -->
					<v-text-field
						id="email-input"
						v-model.trim="$v.formData.email.$model"
						type="email"
						hint="Ej: correo@correo.com"
						label="Correo Electronico"
						dense
						filled
						outlined
						required
						:error-messages="emailErrors"
						@input="$v.formData.email.$touch()"
						@blur="$v.formData.email.$touch()"
					/>
					<!-- password -->
					<v-text-field
						id="email-password"
						v-model.trim="$v.formData.password.$model"
						type="password"
						label="Contraseña"
						dense
						filled
						outlined
						required
						hide-details
						:error-messages="passwordErrors"
						@input="$v.formData.password.$touch()"
						@blur="$v.formData.password.$touch()"
					/>
				</v-card-text>
				<v-card-actions>
					<v-btn :loading="loading" block color="primary" small @click="onSubmit">
						Finalizar Registro
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>
import Logo from '@/assets/logo';
import { mapGetters, mapMutations } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import { guestRegister, evaluateGuestPerson } from '@/plugins/auth';
import evaluateErrorReturn from '@/utils/errors/evaluateErrorReturn';

export default {
	components: {
		Logo,
	},
	mixins: [validationMixin],
	props: {
		personId: { type: String, required: true },
		person: { type: Object, default: null },
		token: { type: String, required: true },
		finaltext: { type: String, default: '' },
	},
	data() {
		return {
			showText: true,
			loading: false,
			companyErrors: '',
			renderForm: false,
			formData: {
				name: '',
				email: '',
				password: '',
				role: 'person',
				analyst: false,
			},
		};
	},
	computed: {
		emailErrors() {
			const errors = [];
			if (!this.$v.formData.email.$dirty) return errors;
			!this.$v.formData.email.required && errors.push('El Correo electronico es querido');
			!this.$v.formData.email.email && errors.push('Escriba un email valido');
			return errors;
		},
		isPerson() {
			return this.formData.role === 'person';
		},
		passwordErrors() {
			const errors = [];
			if (!this.$v.formData.password.$dirty) return errors;
			!this.$v.formData.password.required && errors.push('La contraseña es querida');
			!this.$v.formData.password.maxLength && errors.push('Maximo 200 caracteres');
			!this.$v.formData.password.minLength && errors.push('Minimo 3 caracteres');
			return errors;
		},
		...mapGetters({
			message: 'Auth/message',
		}),
	},
	validations: {
		formData: {
			email: { required, email },
			password: {
				required,
				minLength: minLength(5),
				maxLength: maxLength(100),
			},
		},
	},
	mounted() {
		this.evaluateGuestPerson();
	},
	methods: {
		async onSubmit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				try {
					const { formData, personId } = this;
					this.loading = true;
					const data = await guestRegister({ ...formData, personId }, this.token);
					const { user } = data;
					this.snackbar({
						content: `Bienvenido ${user.name}`,
						color: 'success',
					});
					this.$router.push({ name: 'account-guest', path: '/guest/account' });
				} catch (error) {
					this.snackbar({
						content: evaluateErrorReturn(error),
						color: 'error',
					});
				} finally {
					this.loading = false;
				}
			}
		},
		async evaluateGuestPerson() {
			try {
				const data = await evaluateGuestPerson(this.personId, this.token);
				setTimeout(() => {
					this.showText = false;
					if (data.exist)
						this.$router.push({ name: 'account-guest', path: '/guest/account' });
					else this.renderForm = !data.exist;
				}, 1500);
			} catch (e) {
				this.showText = false;
				this.snackbar({
					content: evaluateErrorReturn(e),
					color: 'error',
				});
			}
		},
		setRole(role) {
			this.formData.role = role;
		},
		...mapMutations({ snackbar: 'Snackbar/showMessage' }),
	},
};
</script>
<style scoped></style>
